export default __webpack_public_path__ + "images/hr-00a76e1b588a62b0fad98dd62bd1283b.svg";